import { render, staticRenderFns } from "./OrgSettingsPage.vue?vue&type=template&id=fd0d17de&scoped=true"
import script from "./OrgSettingsPage.vue?vue&type=script&lang=js"
export * from "./OrgSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./OrgSettingsPage.vue?vue&type=style&index=0&id=fd0d17de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0d17de",
  null
  
)

export default component.exports